<template>
    <Modal
      v-model="show"
      :title="modalTitle"
      :mask-closable="false"
      width="600"
      @on-cancel="modalCancel"
    >
      <div class="content-box">
        <!--工作时间-->
        <!-- <div class="box mar-btm v_center"> -->
          <!-- <div class="label">日期</div>
          <Select v-model="info.beginWeekValue" class="input box_f1">
            <Option v-for="item in weekDay" :value="item.value" :key="item.value">{{ item.label}}</Option>
          </Select>
          <div>至</div>
          <Select v-model="info.endWeekValue" class="input box_f1">
            <Option v-for="item in weekDay" :value="item.value" :key="item.value">{{ item.label}}</Option>
          </Select>
        </div> -->
        <div class="box mar-btm v_center">
          <div class="label">时间</div>
          <TimePicker type="time" format="HH:mm" :value="info.beginTime" class="input box_f1"
                      @on-change="changeStart"></TimePicker>
          <div>至</div>
          <TimePicker type="time" format="HH:mm" :value="info.endTime" class="input box_f1" @on-change="changeEnd"></TimePicker>
        </div>
          <div class="box v_center">
          <div class="limit-label">预约限制</div>
          <div class="limit-input">
            <Input v-model="info.limitCount" type="number" /> 
            <div class="person">人</div>
          </div>     
        </div>
      </div>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button type="text" @click="modalCancel">取消</Button>
        <Button type="primary" @click="confirmTime">确定</Button>
      </div>
    </Modal>
  </template>
  
  <script>
    export default {
      props: {
        modalTitle:{
          type:String,
          default:'预约时间'
        },
        showModel: {
          default: false,
          type: Boolean
        },

        timeItem: null,
      },
      name: 'timeModal',
      data() {
        return {
          show: false,
          info: {
            beginTime: '',
            endTime: '',
            limitCount:'',
            
          },
          weekDay: [{
            label: '周一',
            value: 1,
          }, {
            label: '周二',
            value: 2,
          }, {
            label: '周三',
            value: 3,
          }, {
            label: '周四',
            value: 4,
          }, {
            label: '周五',
            value: 5,
          }, {
            label: '周六',
            value: 6,
          }, {
            label: '周日',
            value: 0,
          }]
        }
      },
      watch: {
        showModel() {
          this.show = this.showModel
        },
        timeItem() {
          if (!_.isEmpty(this.timeItem)) this.info = JSON.parse(JSON.stringify(this.timeItem))
        }
      },
      methods: {
        modalCancel() {
          this.$emit('closeModal')
        },
        changeStart(e) {
          this.info.beginTime = e
        },
        changeEnd(e) {
          this.info.endTime = e
        },
        confirmTime() {
          for(let key  in this.info){
            console.log(key,'==',this.info[key])
            if (key!= 'id' && this.info[key] === '') {
              this.$Message.warning('请完善时间')
              return
            }
            if(key!= 'id' && this.info.limitCount < 0) {
              this.$Message.warning('预约限制人数需大于零')
              return
            }
            if(this.info.limitCount.toString().indexOf(".") != -1) {
               this.$Message.warning('预约限制人数为整数')
              return
            }
          }
          this.$emit('handleTime',this.info)
        },
      }
    }
  </script>
  
  <style scoped lang="less">
    .mar-btm {
      margin-bottom: 20px;
    }
    .v_center {
      align-items: center;
    }
    .label {
      width: 60px;
      text-align: right;
    }
    .limit-label{
      width: 60px;
      margin-left:5px;
      margin-right: 5px;
    }
    .limit-input {
      display: flex;
      width: 86%;
      align-items: center;
    }
    .person {
      width: 5%;
      text-align: right;
    }
    .content-box {
      font-size: 14px;
      padding-bottom: 30px;
      .item-wrapper {
        align-items: center;
      }
      .name {
        width: 60px;
        margin-right: 20px;
        text-align: right;
      }
      .input {
        /*width: 160px;*/
        margin: 0 10px
      }
      .pic-box {
        align-items: center;
        flex-wrap: wrap;
      }
      .pic-wrapper {
        height: 40px;
        width: 40px;
        position: relative;
        margin-right: 20px;
        margin-bottom: 20px;
        .select-pic {
          height: 15px;
          width: 15px;
          position: absolute;
          top: -7px;
          right: -7px;
        }
        .pic {
          height: 100%;
          width: 100%;
        }
      }
    }
  </style>
  